export const getVariantIdTail = (variantId: string): string => {
  const marker = ':variant:';
  const lastIndex = variantId.lastIndexOf(marker);

  if (lastIndex === -1) {
    return variantId;
  }

  return variantId.slice(lastIndex + marker.length);
};

export const variantIdsMatch = (left: string, right: string): boolean =>
  left === right || getVariantIdTail(left) === getVariantIdTail(right);
